import get from 'lodash/get';

export default {
  data() {
    return {
      xhrErrors: [],
      xhrMessage: null,
    };
  },

  methods: {
    resetXhrErrors() {
      (this.xhrErrors = []), (this.xhrMessage = null);
    },

    handleAxiosValidationErrors(e) {
      return new Promise((resolve, reject) => {
        if (get(e, 'response.status') === 422) {
          this.xhrErrors = e.response.data.errors;
          this.xhrMessage = e.response.data.message;
          resolve(e);
        } else {
          reject(e);
        }
      });
    },

    handleFetchValidationErrors(response) {
      return new Promise((resolve, reject) => {
        if (get(response, 'status') === 422) {
          response.json().then((data) => {
            this.xhrErrors = data.errors;
            this.xhrMessage = data.message;
            resolve(response);
          });
        } else {
          reject(response);
        }
      });
    },

    getErrors(name) {
      return get(this.xhrErrors, name, []);
    },

    hasErrors(name) {
      if (!name) {
        return this.xhrErrors.length > 0;
      }

      return !!get(this.xhrErrors, name, []);
    },
  },
};
